(() => {
  const script = document.querySelector('[data-instafeed-enhancements]');
  if (!script) return;

  const ctaEnable = script.getAttribute('data-cta-enable') === 'true';
  const ctaLabel = script.getAttribute('data-cta-label') || 'Find us on social';
  const ctaLink = script.getAttribute('data-cta-link') || '';
  const autoplay = script.getAttribute('data-autoplay') === 'true';
  const speedSeconds = Math.max(1, Number(script.getAttribute('data-autoplay-speed') || 7));
  const INTERVAL_MS = speedSeconds * 1000;
  const GAP_PX = 10;
  const VISIBLE_DESKTOP = 4;
  const VISIBLE_MOBILE = 2;

  let enhanced = false;
  let timerId = null;
  let resizeTimer = null;
  let layoutTimer = null;
  let applyingLayout = false;

  const visibleCount = () => (window.matchMedia('(max-width: 980px)').matches ? VISIBLE_MOBILE : VISIBLE_DESKTOP);

  const findNextControl = (feed) => {
    const selectors = [
      '.instafeed-new-layout-container [class*="next"]',
      '.instafeed-new-layout-container [class*="Next"]',
      '.instafeed-new-layout-container [aria-label*="Next"]',
      '#insta-feed .slick-next',
      '#insta-feed .swiper-button-next',
    ];

    for (const selector of selectors) {
      try {
        const el = feed.querySelector(selector);
        if (el) return el;
      } catch (_) {
        /* ignore */
      }
    }

    const candidates = Array.from(
      feed.querySelectorAll('button, [role="button"], .slick-next, .swiper-button-next')
    ).filter((el) => {
      const rect = el.getBoundingClientRect();
      const label = `${el.getAttribute('aria-label') || ''} ${el.className || ''}`.toLowerCase();
      if (label.includes('prev') || label.includes('previous')) return false;
      return rect.width > 0 && rect.height > 0;
    });

    if (!candidates.length) return null;
    return candidates.sort((a, b) => b.getBoundingClientRect().left - a.getBoundingClientRect().left)[0];
  };

  const injectCta = (feed) => {
    const existing = feed.querySelector('[data-instafeed-cta], .instafeed-cta');
    if (existing) return;
    if (!ctaEnable || !ctaLabel) return;

    const heading = feed.querySelector('h2');
    if (!heading) return;

    let header = feed.querySelector('[data-instafeed-header]');
    if (!header) {
      header = document.createElement('div');
      header.className = 'instafeed-header';
      header.setAttribute('data-instafeed-header', '');
      heading.parentNode.insertBefore(header, heading);
      header.appendChild(heading);
    }

    const cta = document.createElement(ctaLink ? 'a' : 'span');
    cta.className = 'instafeed-cta';
    cta.setAttribute('data-instafeed-cta', '');
    cta.textContent = ctaLabel;
    if (ctaLink) {
      cta.href = ctaLink;
      cta.target = '_blank';
      cta.rel = 'noopener noreferrer';
    }
    header.appendChild(cta);
  };

  /**
   * Instafeed set inline gap + width item. Kalau gap diganti tanpa hitung ulang width,
   * gambar kanan terpotong. Jadi: gap 10px + hitung ulang lebar item.
   */
  const applyLayoutGap = (feed) => {
    const wrapper = feed.querySelector('.instafeed-new-layout-wrapper');
    const container = feed.querySelector('.instafeed-new-layout-container') || wrapper;
    if (!wrapper || !container) return;

    applyingLayout = true;

    const count = visibleCount();
    const containerWidth = container.getBoundingClientRect().width;
    if (containerWidth < 40) {
      applyingLayout = false;
      return;
    }

    const itemWidth = Math.floor((containerWidth - GAP_PX * (count - 1)) / count);

    wrapper.style.setProperty('gap', `${GAP_PX}px`, 'important');
    wrapper.style.setProperty('column-gap', `${GAP_PX}px`, 'important');
    wrapper.style.setProperty('row-gap', `${GAP_PX}px`, 'important');

    wrapper.querySelectorAll('.instafeed-new-layout-item').forEach((item) => {
      item.style.setProperty('width', `${itemWidth}px`, 'important');
      item.style.setProperty('height', `${itemWidth}px`, 'important');
      item.style.setProperty('flex-shrink', '0', 'important');
      item.style.setProperty('min-width', `${itemWidth}px`, 'important');
      item.style.setProperty('max-width', `${itemWidth}px`, 'important');
      item.style.setProperty('box-sizing', 'border-box', 'important');
    });

    window.setTimeout(() => {
      applyingLayout = false;
    }, 50);
  };

  const scheduleLayout = (feed) => {
    window.clearTimeout(layoutTimer);
    layoutTimer = window.setTimeout(() => {
      if (applyingLayout) return;
      applyLayoutGap(feed);
      injectCta(feed);
    }, 80);
  };

  const stopAutoplay = () => {
    if (!timerId) return;
    window.clearInterval(timerId);
    timerId = null;
  };

  const startAutoplay = (feed) => {
    if (!autoplay) return;
    stopAutoplay();

    timerId = window.setInterval(() => {
      const next = findNextControl(feed);
      if (!next) return;
      next.click();
    }, INTERVAL_MS);
  };

  const bindHoverPause = (feed) => {
    if (feed.dataset.instafeedHoverBound === 'true') return;
    feed.dataset.instafeedHoverBound = 'true';

    feed.addEventListener('mouseenter', stopAutoplay);
    feed.addEventListener('mouseleave', () => {
      if (!feed.querySelector('[data-instafeed-freeze]')) startAutoplay(feed);
    });
  };

  const bindLayoutObserver = (feed) => {
    if (feed.dataset.instafeedLayoutBound === 'true') return;
    feed.dataset.instafeedLayoutBound = 'true';

    const observer = new MutationObserver(() => {
      if (applyingLayout) return;
      scheduleLayout(feed);
    });

    observer.observe(feed, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true,
    });
  };

  const enhance = () => {
    const feed = document.getElementById('insta-feed');
    if (!feed || enhanced) return false;

    const hasContent =
      feed.querySelector('h2') ||
      feed.querySelector('.instafeed-new-layout-container') ||
      feed.querySelector('.instafeed-new-layout-wrapper') ||
      feed.querySelector('img');

    if (!hasContent) return false;

    injectCta(feed);
    applyLayoutGap(feed);
    bindLayoutObserver(feed);
    bindHoverPause(feed);
    startAutoplay(feed);
    enhanced = true;

    window.setTimeout(() => scheduleLayout(feed), 300);
    window.setTimeout(() => scheduleLayout(feed), 900);
    window.setTimeout(() => scheduleLayout(feed), 1800);
    return true;
  };

  const onResize = () => {
    const feed = document.getElementById('insta-feed');
    if (!feed || !enhanced) return;

    stopAutoplay();
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      applyLayoutGap(feed);
      injectCta(feed);
      if (!feed.matches(':hover')) startAutoplay(feed);
    }, 280);
  };

  const watch = () => {
    if (enhance()) return;

    const observer = new MutationObserver(() => {
      if (enhance()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 20000);
  };

  document.addEventListener('instafeedAppLoaded', () => {
    enhanced = false;
    stopAutoplay();
    enhance();
  });

  window.addEventListener('resize', onResize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
